import React, { useState, useEffect } from 'react';
import { Button, IconButton } from "@material-tailwind/react";
import { ChatScreen } from './components/ChatScreen';
import { HelpCenter } from './components/HelpCenter';
import { EmailForm } from './components/EmailForm';
import config from './config';

function App() {
  const [currentView, setCurrentView] = useState('chat'); // 'chat', 'whatsapp', 'facebook', 'email', 'info'
  const [chatOpen, setChatOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const companyId = 'GnsrqEu7CD0Vz7FCj4JsHi7PvzxUvekn'

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setChatOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSocialClick = (platform) => {
    const url = platform === 'whatsapp'
      ? `https://wa.me/${config.whatsappNumber}`
      : config.facebookLink;
    window.open(url, '_blank');
  };

  const renderContent = () => {
    switch (currentView) {
      case 'email':
        return <EmailForm onBack={() => setCurrentView('chat')} />;
      case 'info':
        return <HelpCenter companyId={config.companyId} onBack={() => setCurrentView('chat')} />;
      default:
        return <ChatScreen companyId={config.companyId} onClose={() => setChatOpen(false)} />;
    }
  };

  return (
    <div className="flex flex-col h-screen transition-all duration-100">
      <div
        id="chatBot"
        className={`fixed zIndex rounded-lg shadow-xl bg-white z-50 border dark:bg-[#171B1C] dark:border-black ${isMobile
          ? 'bottom-14 left-1/2 transform -translate-x-1/2'
          : 'bottom-16 right-9'
          }`}
        style={{
          width: '300px',
          height: 'calc(100vh - 200px)',
          maxHeight: '600px',
          minHeight: '400px'
        }}
      >
        {renderContent()}

        {/* Navigation Bar */}
        <div className="absolute bottom-0 left-0 right-0 h-12 border-t bg-white dark:bg-[#171B1C] flex justify-around items-center px-4">
          <IconButton
            variant="text"
            size="sm"
            onClick={() => setCurrentView('chat')}
            className={currentView === 'chat' ? "text-blue-500" : "dark:text-white"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-[22px]">
              <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
            </svg>

          </IconButton>
          <IconButton
            variant="text"
            size="sm"
            onClick={() => handleSocialClick('whatsapp')}
            className="dark:text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="800"
              height="800"
              fill="none"
              viewBox="0 0 24 24"
              className="size-[22px]"
            >
              <path
                fill="#000"
                d="m2 22 1.412-5.13a9.9 9.9 0 0 1-1.321-4.95C2.081 6.445 6.526 2 11.99 2a9.85 9.85 0 0 1 7.016 2.903 9.85 9.85 0 0 1 2.904 7.017c0 5.463-4.446 9.909-9.91 9.909a9.83 9.83 0 0 1-4.738-1.21zm5.494-3.165.303.181a8.24 8.24 0 0 0 4.193 1.15c4.536 0 8.236-3.7 8.236-8.237a8.2 8.2 0 0 0-2.41-5.826 8.2 8.2 0 0 0-5.826-2.42c-4.547 0-8.245 3.7-8.245 8.237a8.2 8.2 0 0 0 1.26 4.385l.191.313-.836 3.044z"
              ></path>
              <path
                fill="#000"
                fillRule="evenodd"
                d="M9.52 7.767c-.181-.414-.383-.424-.554-.424-.151-.01-.313-.01-.484-.01a.92.92 0 0 0-.665.312c-.232.252-.867.847-.867 2.067s.887 2.4 1.008 2.56c.12.162 1.713 2.742 4.234 3.74 2.096.827 2.52.666 2.974.615.453-.05 1.462-.594 1.673-1.18.202-.574.202-1.078.141-1.179-.06-.1-.232-.161-.474-.292-.252-.12-1.461-.726-1.693-.807-.232-.08-.394-.12-.555.121-.161.253-.635.807-.786.968-.141.162-.292.182-.534.06-.252-.12-1.049-.382-1.996-1.23-.736-.655-1.23-1.47-1.382-1.712-.14-.253-.02-.384.111-.505.112-.11.253-.292.374-.433.12-.142.16-.253.252-.414.08-.161.04-.312-.02-.433-.061-.11-.535-1.331-.757-1.825"
                clipRule="evenodd"
              ></path>
            </svg>
          </IconButton>
          <IconButton
            variant="text"
            size="sm"
            onClick={() => handleSocialClick('facebook')}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="800"
              height="800"
              viewBox="0 0 32 32"
              className="size-[22px]"
            >
              <path d="m21.95 5.005-3.306-.004c-3.206 0-5.277 2.124-5.277 5.415v2.495H10.05v4.515h3.317l-.004 9.575h4.641l.004-9.575h3.806l-.003-4.514h-3.803v-2.117c0-1.018.241-1.533 1.566-1.533l2.366-.001z"></path>
            </svg>
          </IconButton>
          <IconButton
            variant="text"
            size="sm"
            onClick={() => setCurrentView('email')}
            className={currentView === 'email' ? "text-blue-500" : "dark:text-white"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-[22px]">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
            </svg>

          </IconButton>
          <IconButton
            variant="text"
            size="sm"
            onClick={() => setCurrentView('info')}
            className={currentView === 'info' ? "text-blue-500" : "dark:text-white"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-[22px]">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
            </svg>

          </IconButton>
        </div>
      </div>
    </div >
  );
}

export default App;